import navbarDataToRepartitionDataMapper from "@/mappers/repartitionDataMapper";
import { useNavBarContent } from "@cs_teamwaydev/mailvista-sdk_react";
import { useMemo } from "react";
import useLiveErrorNotifier from "../utils/useLiveErrorNotifier";

const useGetDashboardRepartition = () => {
    const { data: navBarContent, isLoading, error } = useNavBarContent();

    useLiveErrorNotifier(error, { titleTranslationKey: "errors.navbar" });

    const data = useMemo(
        () =>
            navBarContent
                ? navbarDataToRepartitionDataMapper(navBarContent)
                : undefined,
        [navBarContent],
    );

    return { data, isLoading };
};

export default useGetDashboardRepartition;
